import { render, staticRenderFns } from "./ModalTriagem.vue?vue&type=template&id=5f57e99e&scoped=true"
import script from "./ModalTriagem.vue?vue&type=script&lang=ts"
export * from "./ModalTriagem.vue?vue&type=script&lang=ts"
import style0 from "./ModalTriagem.vue?vue&type=style&index=0&id=5f57e99e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f57e99e",
  null
  
)

export default component.exports